import { ReactNode } from 'react';

import AuthProviderContext from './contexts/auth-provider-context';
import useAuthProviderState from './states/auth-provider-state';

type Props = {
  children: ReactNode;
};

const AuthProvider = ({ children }: Props): React.JSX.Element => (
  <AuthProviderContext.Provider value={useAuthProviderState()}>{children}</AuthProviderContext.Provider>
);

export default AuthProvider;
